export default __webpack_public_path__ + "static/media/logoCPE.08bb49af.png";